module.exports = __webpack_public_path__ + "static/media/bcbg.ed939d5c.jpg";